import React from 'react';
import BookCover from '../../components/BookCover/BookCover';
import './SearchMain.css';

const config = require('../../config.json');

export default function SearchCardView(props) {
  const { searchResult, handleShow, isArticle } = props;

  const renderStatusBadge = (status, scope) => {
    if (scope === 'Reference') {
      if (status === 'Issued') {
        return <span className="badge-issued"><i className="bi bi-clock me-1"></i> Reference (Issued)</span>;
      }
      return <span className="badge-reference"><i className="bi bi-bookmark-star me-1"></i> Reference</span>;
    }
    if (status === 'Active' || status === 'Available') {
      return <span className="badge-available"><i className="bi bi-check-circle me-1"></i> Available on Shelf</span>;
    }
    if (status === 'Issued') {
      return <span className="badge-issued"><i className="bi bi-clock me-1"></i> Issued / In Use</span>;
    }
    return <span className="badge bg-secondary text-white small px-2 py-1">{status || 'Available'}</span>;
  };

  if (!searchResult || searchResult.length === 0) {
    return null;
  }

  return (
    <div className="row g-3">
      {searchResult.map((item, index) => {
        if (isArticle || item.articleID) {
          // Article Card
          const callNumber = item.callNo || item.journalCallNo || `${item.bookClassificationNo || ''} ${item.authorMark || ''}`.trim();
          const parentTitle = item.journalTitle || item.bookTitle || '';

          return (
            <div key={item.articleID || item.accessionNo || index} className="col-12 col-sm-6 col-md-4 col-lg-3">
              <div
                className="vj-book-card"
                onClick={(e) => handleShow(e, item)}
                title="Click to view complete article details"
              >
                {/* Card Header Banner */}
                <div
                  className="p-3 text-center position-relative"
                  style={{
                    background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #4338ca 100%)',
                    color: '#ffffff',
                    minHeight: '120px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '12px 12px 0 0'
                  }}
                >
                  <div
                    style={{
                      width: '46px',
                      height: '46px',
                      borderRadius: '50%',
                      background: 'rgba(255, 255, 255, 0.2)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '22px',
                    }}
                  >
                    <i className="bi bi-file-earmark-text"></i>
                  </div>
                  {item.volissuesNo && (
                    <div className="position-absolute top-0 end-0 p-2">
                      <span className="badge bg-info text-dark small px-2 py-1">
                        Vol. {item.volissuesNo}
                      </span>
                    </div>
                  )}
                  {item.accessionNo && !item.volissuesNo && (
                    <div className="position-absolute top-0 end-0 p-2">
                      <span className="badge bg-white text-dark small px-2 py-1 font-monospace">
                        Acc #{item.accessionNo}
                      </span>
                    </div>
                  )}
                  {item.articleStatus && (
                    <div className="position-absolute top-0 start-0 p-2">
                      <span className="badge bg-success small px-2 py-1">
                        {item.articleStatus}
                      </span>
                    </div>
                  )}
                </div>

                {/* Card Body */}
                <div className="vj-book-card-body">
                  <div>
                    {callNumber ? (
                      <div className="vj-callno-badge mb-2">
                        <i className="bi bi-geo-alt-fill text-primary"></i> Call No: <strong>{callNumber}</strong>
                      </div>
                    ) : (item.journalID || item.articleID) ? (
                      <div className="vj-callno-badge mb-2">
                        <i className="bi bi-journal-bookmark text-primary"></i> #{item.journalID || item.articleID}
                      </div>
                    ) : null}

                    <h6 className="vj-article-card-title" title={item.articleTitle}>
                      {item.articleTitle}
                    </h6>

                    {item.articleSubTitle && (
                      <div className="small text-muted fst-italic mb-1 text-truncate" title={item.articleSubTitle}>
                        {item.articleSubTitle}
                      </div>
                    )}

                    <div className="vj-article-card-author">
                      <i className="bi bi-person me-1 text-muted"></i>
                      {item.articleAuthor || 'Unknown Author'}
                    </div>

                    {parentTitle && (
                      <div className="small text-secondary mt-2 pt-1 border-top text-truncate" title={`Host: ${parentTitle}`}>
                        <i className="bi bi-journal-album text-primary me-1"></i>
                        <strong className="text-dark">Journal:</strong> {parentTitle}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-between align-items-center pt-2 border-top mt-2 small text-muted">
                    <span className="text-truncate" style={{ maxWidth: '140px' }} title={item.articleKeywords || 'Catalogue Article'}>
                      <i className="bi bi-tag me-1"></i> {item.articleKeywords || 'Article'}
                    </span>
                    <span className="font-monospace text-primary fw-bold">
                      {item.startPageNo && item.endPageNo ? `pp. ${item.startPageNo}-${item.endPageNo}` : (item.articleID || `#${item.accessionNo}`)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        }

        // Book Card
        const isBoundJournal = (item.bookAuthor || '').trim().toLowerCase() === 'bound journal';
        const callNumber = `${item.bookClassificationNo || ''} ${item.authorMark || ''}`.trim();
        const posterUrl = `${config.s3.bookPoster}${item.accessionNo}.jpeg`;

        return (
          <div key={item.accessionNo || index} className="col-12 col-sm-6 col-md-4 col-lg-3">
            <div
              className="vj-book-card"
              onClick={(e) => handleShow(e, item)}
              title={isBoundJournal ? "Bound Journal - Click to view volume issues and shelf location" : "Click to view complete details and shelf location"}
            >
              {/* Card Image Area */}
              <div className="vj-book-card-img-wrapper d-flex justify-content-center align-items-center bg-light" style={{ height: '220px', padding: '10px' }}>
                <BookCover
                  title={item.bookTitle}
                  author={item.bookAuthor}
                  edition={item.bookEdition}
                  category={item.bookCategory}
                  callNumber={item.bookClassificationNo}
                  accessionNo={item.accessionNo}
                  imageUrl={posterUrl}
                  size="md"
                  style={{ width: '100%', height: '100%', maxHeight: '200px' }}
                />
                <div className="position-absolute top-0 end-0 p-2 d-flex flex-column align-items-end gap-1" style={{ zIndex: 10 }}>
                  {renderStatusBadge(item.bookStatus, item.bookScope)}
                  {isBoundJournal && (
                    <span className="badge-bound-journal">
                      <i className="bi bi-journal-bookmark-fill"></i> Bound Journal
                    </span>
                  )}
                </div>
              </div>

              {/* Card Body */}
              <div className="vj-book-card-body">
                <div>
                  {/* Call Number / Shelf Location Badge */}
                  <div className="d-flex flex-wrap align-items-center gap-1 mb-2">
                    {callNumber ? (
                      <div className="vj-callno-badge mb-0" title="Locate this on the library shelf">
                        <i className="bi bi-geo-alt-fill text-primary"></i> Call No: {callNumber}
                      </div>
                    ) : isBoundJournal ? (
                      <div className="vj-callno-badge mb-0" title="Bound Journal Collection">
                        <i className="bi bi-journal-album text-primary"></i> Bound Volume
                      </div>
                    ) : null}
                    {isBoundJournal && (
                      <span className="badge-bound-journal-subtle">
                        <i className="bi bi-journal-bookmark-fill"></i> Bound Journal
                      </span>
                    )}
                  </div>

                  {/* Title */}
                  <h6 className="vj-book-card-title" title={item.bookTitle}>
                    {item.bookTitle}
                  </h6>

                  {/* Author */}
                  <div className="vj-book-card-author">
                    {isBoundJournal ? (
                      <span className="text-primary fw-semibold d-inline-flex align-items-center gap-1">
                        <i className="bi bi-journal-bookmark-fill"></i> Bound Journal
                      </span>
                    ) : (
                      <>
                        <i className="bi bi-person me-1 text-muted"></i>
                        {item.bookAuthor || 'Unknown Author'}
                      </>
                    )}
                  </div>
                </div>

                {/* Footer Metadata */}
                <div className="d-flex justify-content-between align-items-center pt-2 border-top mt-2 small text-muted">
                  <span className="text-truncate" style={{ maxWidth: '130px' }} title={item.bookCategory}>
                    <i className="bi bi-tag me-1"></i> {item.bookCategory || (isBoundJournal ? 'Periodical' : 'Theology')}
                  </span>
                  <span className="font-monospace fw-bold text-primary">
                    #{item.accessionNo}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
